// -------------------------------
// グローバル関数宣言
// -------------------------------

// URLパラメータ取得
window.getParameterByName = function (name) {
  name = name.replace(/[\[\]]/g, '\\$&')
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(window.location.href)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

// タグ除去
window.tagReplace = function (text) {
  return text.replace(/<.+?>/g, '')
}

// gtagイベント送信
window.gtmEvent = function (q, a) {
  let event = q + '___' + a
  if (typeof gtag !== 'undefined') {
    console.log(event)
    gtag('event', event)
  } else {
    console.log('gtag undefined')
    console.log(event)
  }
}

// Meta Pixelイベント送信
window.metaEvent = function (q, a) {
  if (typeof fbq === 'function') {
    let event = q + '___' + a
    console.log('Sending Meta event:' + event)
    fbq('track', event)
  } else {
    console.log('Meta Pixel is not initialized. Event not sent: ' + q + ':' + a)
  }
}

// QA出力切替アニメーション
// window.showQuestion = function (newHtml) {
//   let $contents = $('.diag-contents')
//   $contents.removeClass('active').fadeOut(500, function () {
//     $contents.html(newHtml)
//     $contents.fadeIn(500, function () {
//       $contents.addClass('active')
//     })
//   })
// }
window.showQuestion = function (newHtml) {
  let $contents = $('.diag-contents')

  $contents.css('opacity', 0)

  setTimeout(function () {
    $contents.html(newHtml)
    $contents.css('opacity', 1)
  }, 250)
}

// JSON取得
window.currentQaJsonUrl = ''
window.currentQaId = ''

window.qa = function (url, id) {
  //Shopify
  let fileName = url
  url = qaJsonUrl[fileName] || fileName
  //ここまで

  window.currentQaJsonUrl = url
  window.currentQaId = id
  $.ajax({
    type: 'GET',
    dataType: 'json',
    url: url,
    cache: false,
    timeout: 10000,
  })
    .done(function (data) {
      window.qaOutput(data[id])
    })
    .fail(function () {
      console.log('結果内容処理エラー')
    })
    .always(function () {
      console.log('結果内容処理完了')
    })
}

// QA内容レンダリング
window.qaOutput = function (data) {
  let id = data.id
  let title = data.title
  let text = data.text
  let img = data.img

  //Shopify
  let fileName = data.img
  img = assetUrls[fileName] || fileName
  //ここまで

  let padding = data.padding
  let color = data.color
  let bgColor = color.bgColor ? 'background-color:' + color.bgColor : ''
  let titleColor = color.titleColor
  let contents,
    lastContents,
    imgContents = ''

  if (id == 'thanks') {
    let link = data.link
    let linkContents
    if (img) {
      if (checkFileType(img) == 'video') {
        imgContents = `<video src="${img}" loop autoplay muted playsinline></video>`
      } else {
        imgContents = `<img src="${img}" alt="${window.tagReplace(title)}">`
      }
    }
    linkContents = link ? `<a href="${link}" target="_blank" class="cta-btn">${imgContents}</a>` : imgContents

    contents = `<div class="diag-contents" style="${bgColor}"><div class="loading" style="color:${color.btnColor};">Loading...</div></div>`
    lastContents = `<div class="diag-contents" style="${bgColor}">${linkContents}</div>`

    window.showQuestion(contents)
    setTimeout(() => {
      window.showQuestion(lastContents)
    }, 1500)
  } else if (id == 'start') {
    let next = data.next
    if (img) {
      if (checkFileType(img) == 'video') {
        imgContents = `<video src="${img}" loop autoplay muted playsinline></video>`
      } else {
        imgContents = `<img src="${img}" alt="${window.tagReplace(title)}">`
      }
    }
    let button = next
      ? `<button data-que="${id}" data-ans="設問開始" data-next="${next}">${imgContents}</button>`
      : imgContents
    contents = `<div class="diag-contents start-wrap" style="${bgColor}">${button}</div>`
    window.showQuestion(contents)
  } else {
    let ans = data.ans || []
    let btnType = data.btnType || 1 // デフォルト
    let row = data.row || 2
    let qID = `<span class="qid" style="background-color:${titleColor}">${id}</span>`
    let textContents = `
            <div class="text-wrap">
                <h2 style="color:${titleColor}">${qID}${title}</h2>
                <div class="text">${text}</div>
            </div>`

    let ansLength = ans.length <= 4 ? 'tworows' : ans.length <= 6 ? 'threerows' : ''
    row = `grid-template-columns: repeat(${row}, 1fr);`
    let ansContents = `<div class="ans-wrap ${ansLength}" style="${row}">`

    for (let i in ans) {
      let fontSize = 'font-size:' + (ans[i].fontSize || '1.2em') + ';'
      let outlineColor = 'outline-color:' + color.btnColor + ';'
      let textColor = 'color:' + color.btnTextColor + ';'
      let lineHeight = 'line-height:' + (ans[i].lineHeight || '1.5') + ';'
      let paddingsize = 'padding:' + padding + ';'
      ansContents += `
                <button class="type${btnType}" data-btnColor="${color.btnColor}" 
                    data-que="${id}" data-ans="${window.tagReplace(ans[i].text)}" 
                    data-next="${ans[i].next}" 
                    style="${fontSize}${outlineColor}${textColor}${lineHeight}${paddingsize}">
                    ${ans[i].text}
                </button>`
    }
    ansContents += '</div>'

    if (img) {
      if (checkFileType(img) == 'video') {
        imgContents = `<video src="${img}" loop autoplay muted playsinline></video>`
      } else {
        imgContents = `<img src="${img}" alt="${window.tagReplace(title)}">`
      }
    }

    contents = img
      ? `<div class="diag-contents" style="${bgColor}"><div class="diag-imgcontents">${imgContents}${ansContents}</div></div>`
      : `<div class="diag-contents" style="${bgColor}"><div class="diag-subcontents">${textContents}${ansContents}</div></div>`
    window.showQuestion(contents)
  }

  // ボタン装飾
  $('button.type1').each(function () {
    let bgcolor = $(this).attr('data-btnColor')
    $(this).css({
      'background-color': bgcolor,
      'box-shadow': `0px 5px 0px color-mix(in srgb, ${bgcolor}, black 30%)`,
    })
  })
  $(document).on(
    {
      mouseenter: function () {
        let bgcolor = $(this).attr('data-btnColor')
        $(this).css({
          'background-color': bgcolor,
          color: '#ffffff',
          'outline-color': color.btnColor,
        })
      },
      mouseleave: function () {
        $(this).css({
          'background-color': '#ffffff',
          color: color.btnTextColor,
          'outline-color': color.btnColor,
        })
      },
    },
    'button.type2',
  )
}

// コンテンツHTML出力
window.contentsOutput = function (pc, sp, introductionBanner) {
  let contents = ''
  if (introductionBanner) {
    contents = `
      <div class="popup_banner">
          <div class="popup_banner-close">×</div>
          <picture>
              <source media="(min-width: 550px)" srcset="${pc}">
              <img src="${sp}" alt="">
          </picture>
      </div>`
  }
  contents += `
  <div class="modal-container">
      <div class="modal-body">
          <div class="modal-close">×</div>
          <div class="modal-content">
              <div class="diag-wrap"><div class="diag-contents"></div></div>
          </div>
      </div>
  </div>`
  $('body').append(contents)
}
window.bannerOutput = function (pc, sp, target) {
  let contents = `
        <div class="popup_banner-close">×</div>
        <picture>
            <source media="(min-width: 550px)" srcset="${pc}">
            <img src="${sp}" alt="">
        </picture>`
  $('.popup_banner').html(contents)
  $('.popup_banner').attr('data-target', target)
}

// モーダル制御
window.Modal = function (open, close, container) {
  // 開くボタンをクリックしたらモーダルを表示する
  $(document).on('click', open, function () {
    targetClass()
    setTimeout(function () {
      $(container).addClass('active')
    }, 100)

    return false
  })
  // 閉じるボタンをクリックしたらモーダルを閉じる
  $(document).on('click', close, function () {
    $(container).removeClass('active')
  })
  // 外側クリックで閉じる処理
  /*
    $(document).on('click',function(e) {
        if(!$(e.target).closest('.modal-body').length) {
            $(container).removeClass('active');
        }
    });
    */
}
/*
function isElementInViewport($elem) {
    if (!$elem.length) return false;

    let elemTop = $elem.offset().top;
    let elemBottom = elemTop + $elem.outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return (elemBottom > viewportTop) && (elemTop < viewportBottom);
}
*/

function isElementInViewport($elem) {
  if (!$elem.length) return false

  let winH = $(window).height() // ウィンドウの高さ
  let scroll = $(window).scrollTop() // 現在のスクロール位置
  let objTop = $elem.offset().top // 要素の上端位置

  // ウィンドウ下端が要素の上端を超えた（=画面内に入った）かどうかを判定
  return scroll + winH >= objTop && scroll < objTop
}

function checkPosition() {
  const settings = window.popupSettings
  if (!settings) return

  for (let className in settings) {
    if (className === 'default') continue

    if (window.popupTriggered == className) {
      // 既に処理済みならスキップ
      continue
    }

    let $target = $('.' + className)
    if (!$target.length) continue

    if (isElementInViewport($target)) {
      console.log('処理対象:', className)
      window.popupTriggered = className
      const config = settings[className]
      if (config.banner) {
        window.bannerOutput(config.banner.pc, config.banner.sp, className)
      }
      if (!$('.modal-container').hasClass('active')) {
        window.qa(config.qaJson, config.qaID)
      }
    }
  }
}

function targetClass() {
  let className = $('.popup_banner').attr('data-target')
  console.log(className)
  if (className) {
    window.qa(window.popupSettings[className].qaJson, window.popupSettings[className].qaID)
  } else {
    window.qa(window.popupSettings.default.qaJson, window.popupSettings.default.qaID)
  }
}

function checkFileType(url) {
  let imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
  let videoExtensions = ['mp4', 'webm', 'ogv', 'avi', 'mov']

  let ext = url.split('.').pop().toLowerCase()

  if (imageExtensions.includes(ext)) {
    return 'image'
  } else if (videoExtensions.includes(ext)) {
    return 'video'
  } else {
    return 'unknown'
  }
}

// -------------------------------
// DOM Ready後メイン実行
// -------------------------------
$(function () {
  let modalShown = false

  // 画面ロード時
  $(window).on('load', function () {
    window.popupSettings = qaset().settings
    window.basicSettings = qaset().basic
    window.introductionBanner = window.basicSettings.introductionBanner
    window.scrollModal = window.basicSettings.scrollModal
    window.mouseLeaveEvent = window.basicSettings.mouseLeaveEvent
    window.windowFocusEvent = window.basicSettings.windowFocusEvent
    window.delayModal = window.basicSettings.delayModal
    const defaultBanner = window.popupSettings?.default?.banner || {}
    const pc = defaultBanner.pc || ''
    const sp = defaultBanner.sp || ''
    if (pc || sp) {
      window.contentsOutput(pc, sp, true)
    } else {
      window.contentsOutput('', '', false)
    }
    window.qa(window.popupSettings.default.qaJson, window.popupSettings.default.qaID)

    if (window.mouseLeaveEvent) {
      mouseLeaveEvent()
    }
    if (window.windowFocusEvent) {
      windowFocusEvent()
    }
    if (window.delayModal >= 0) {
      delayModal(window.delayModal)
    }
  })

  //スクロール時
  $(window).on('scroll', function () {
    checkPosition()
    if (window.introductionBanner) {
      PageTopAnime()
    }
    if (window.scrollModal >= 0 && window.scrollModal <= 100) {
      scrollModal(window.scrollModal)
    }
  })

  // モーダルイベント初期化
  window.Modal('.popup_banner', '.modal-close', '.modal-container')

  // ポップアップ導入バナークリック
  $(document).on('click', '.popup_banner', function () {
    $(this).removeClass('UpMove')
    window.gtmEvent('ポップアップ', '表示')
    window.metaEvent('ポップアップ', '表示')
  })

  // 診断回答処理
  $(document).on('click', '.diag-contents button', function () {
    let Que = $(this).attr('data-que')
    let Ans = $(this).attr('data-ans')
    let Next = $(this).attr('data-next')
    let currentJsonUrl = window.currentQaJsonUrl
    let currentQaId = window.currentQaId
    //console.log('現在のJSON', currentJsonUrl, currentQaId);
    window.qa(currentJsonUrl, Next)
    window.gtmEvent(Que, Ans)
    window.metaEvent(Que, Ans)
  })

  // CTAボタン
  $(document).on('click', '.diag-contents .cta-btn', function () {
    window.gtmEvent('POPアップ診断', '送客')
    window.metaEvent('POPアップ診断', '送客')
  })

  // ポップアップ導入バナーのスクロール表示制御
  function PageTopAnime() {
    let scroll = $(window).scrollTop()
    let docHeight = $(document).height()
    let bottom_height = docHeight - 1500
    if (!$('.modal-container').hasClass('active')) {
      if (scroll <= 600 || scroll >= bottom_height) {
        if ($('.popup_banner').hasClass('UpMove')) {
          $('.popup_banner').removeClass('UpMove')
        }
      } else {
        if (!$('.popup_banner').hasClass('disable')) {
          if (!$('.popup_banner').hasClass('UpMove')) {
            $('.popup_banner').addClass('UpMove')
            window.gtmEvent('ポップアップ導入バナー', '表示')
            window.metaEvent('ポップアップ導入バナー', '表示')
          }
        }
      }
    }
    $(document).on('click', '.popup_banner .popup_banner-close', function (event) {
      event.stopPropagation()
      $(this).parent().removeClass('UpMove')
      $(this).parent().addClass('disable')
    })
  }

  // 離脱防止処理
  $(function () {
    let popupShown = false

    function initializeHistory() {
      history.replaceState({ page: 'current' }, null, '')
      history.pushState({ page: 'stopback' }, null, '')
    }

    initializeHistory()

    $(window).on('popstate', function (e) {
      // 履歴位置が「stopback」のときに一度だけポップアップ表示
      if (e.originalEvent.state && e.originalEvent.state.page === 'stopback') {
        // 履歴を戻して戻るのキャンセル
        history.pushState({ page: 'stopback' }, null, '')
        if (!popupShown) {
          popupShown = true
          $('.modal-container').addClass('active')
          window.gtmEvent('ポップアップ', '表示')
          window.metaEvent('ポップアップ', '表示')
        } else {
          // 2回目以降は本来のブラウザバックを許可（ここで戻る動作停止しない）
          popupShown = false // リセットしておく場合
          history.back() // 本来のブラウザバックを実行
        }
      }
    })
  })
  // ウィンドウフォーカス時の離脱防止のアラート
  function windowFocusEvent() {
    $(window).on('focus', function () {
      if (modalShown) return
      $('.modal-container').addClass('active')
      window.gtmEvent('ポップアップ', '表示')
      window.metaEvent('ポップアップ', '表示')
      modalShown = true
    })
  }

  // マウスカーソルが画面外に離脱したとき発火
  function mouseLeaveEvent() {
    $(document).on('mouseleave', function () {
      if (modalShown) return
      console.log('マウスカーソルが画面外に出ました')
      $('.modal-container').addClass('active')
      window.gtmEvent('ポップアップ', '表示')
      window.metaEvent('ポップアップ', '表示')
      modalShown = true
    })
  }

  // スクロール率80%で発火
  function scrollModal(percent) {
    if (modalShown) return
    const scrollTop = $(window).scrollTop()
    const docHeight = $(document).height()
    const windowHeight = $(window).height()
    const scrollPercent = (scrollTop / (docHeight - windowHeight)) * 100

    if (scrollPercent >= percent) {
      $('.modal-container').addClass('active')
      window.gtmEvent('ポップアップ', '表示')
      window.metaEvent('ポップアップ', '表示')
      modalShown = true
    }
  }

  //ページ滞在時間で発火
  function delayModal(delay) {
    setTimeout(function () {
      $('.modal-container').addClass('active')
      window.gtmEvent('ポップアップ', '訪問')
      window.metaEvent('ポップアップ', '訪問')
    }, delay)
  }
})
